var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GooglePayButtonColor } from '../services/ApplicationSession';
/**
 * This file contains the default theme for the Asurion Payment Options component. Use the styled-components
 * ThemeProvider to override these values with another object with the same fields to change the look and feel
 * of the MicroUI components.
 */
export var AsurionTheme = {
    fontFamily: 'Apercu, Helvetica, Arial, sans-serif',
    buttonBackgroundColor: '#8222D2',
    buttonTextColor: '#FFFFFF',
    buttonDisableColor: '#CCC',
    buttonBorderRadius: '10rem',
    paymentOptionDividerFontSize: '16px',
    paymentOptionDividerDividerColor: '#6E767D',
    paymentOptionDividerFontColor: '#6E767D',
    paymentOptionDividerDividerThickness: '1px',
    paymentOptionDividerSplitLength: '16px', // How many pixels on each side of the copy should we mask the bar
    expressPayHeaderFontSize: '16px',
    expressPayHeaderFontColor: '#6E767D',
    fieldGap: '16px',
    googlePayButtonColor: GooglePayButtonColor.BLACK
};
export var CustomThemeProvider = function (overrides) {
    return __assign(__assign({}, AsurionTheme), { fontFamily: (overrides === null || overrides === void 0 ? void 0 : overrides.fontFamily) || AsurionTheme.fontFamily, buttonBackgroundColor: (overrides === null || overrides === void 0 ? void 0 : overrides.continueButtonColor) || AsurionTheme.buttonBackgroundColor, buttonBorderRadius: (overrides === null || overrides === void 0 ? void 0 : overrides.continueButtonBorderRadius) || AsurionTheme.buttonBorderRadius, buttonDisableColor: (overrides === null || overrides === void 0 ? void 0 : overrides.continueButtonDisabledColor) || AsurionTheme.buttonDisableColor, buttonHoverColor: overrides === null || overrides === void 0 ? void 0 : overrides.continueButtonHoverColor, googlePayButtonColor: (overrides === null || overrides === void 0 ? void 0 : overrides.googlePayButtonColor) || AsurionTheme.googlePayButtonColor });
};
